import React from 'react';
import { ArrowLeftOutlined } from 'jl-design-system/components/icons/ArrowLeftOutlined';
import styles from './typeahead-overlay.scss';

const BackButton = ({ onBackButtonClick }) => {
  return (
    <button
      data-testid="typeahead-back-button"
      className={styles.backButton}
      onClick={onBackButtonClick}
    >
      <ArrowLeftOutlined size="medium" className={styles.backIcon} />
      <span>Back</span>
    </button>
  );
};

export default BackButton;
